var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLlmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#032142",
    d: "M 287.183594 144.769531 L 304.984375 105.609375 L 344.148438 87.804688 L 304.984375 70.003906 L 287.183594 30.839844 L 269.382812 70.003906 L 230.21875 87.804688 L 269.382812 105.609375 Z M 180.375 151.890625 L 144.769531 73.566406 L 109.167969 151.890625 L 30.839844 187.496094 L 109.167969 223.097656 L 144.769531 301.425781 L 180.375 223.097656 L 258.699219 187.496094 Z M 287.183594 230.21875 L 269.382812 269.382812 L 230.21875 287.183594 L 269.382812 304.984375 L 287.183594 344.148438 L 304.984375 304.984375 L 344.148438 287.183594 L 304.984375 269.382812 Z M 287.183594 230.21875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlmIcon);
export default __webpack_public_path__ + "static/media/llm-icon.ffeb306a.svg";
export { ForwardRef as ReactComponent };